export const API_SERVERS: Record<string, { serverUrl: string; clientPath: string; token?: string }> = {
  town: {
    serverUrl: process.env.TOWN_INT_API_URL ?? '',
    token: process.env.TOWN_INT_API_KEY ?? '',
    clientPath: '/api/cc/town',
  },
  int: {
    serverUrl: process.env.INT_API_URL ?? '',
    token: process.env.INT_API_KEY ?? '',
    clientPath: '/api/cc/int',
  },
  property: {
    serverUrl: process.env.PROPERTY_INT_API_URL ?? '',
    token: process.env.PROPERTY_INT_API_KEY ?? '',
    clientPath: '/api/cc/property',
  },
} as const;

export type ServerKey = keyof typeof API_SERVERS;
